// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"T8-z"};